import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '../../icons/DesignSystemIcons';

/**
 * Breadcrumb trail — ekinCare DS navigation: chevron separators, last segment active (semibold),
 * preceding links hover to brand blue.
 * @param {{ text: string, link: string }[]} list
 */
const Breadcrumb = ({ list = [], classes = '' }) => {
  if (!list.length) return null;

  const lastIndex = list.length - 1;

  return (
    <nav className={`flex ${classes}`.trim()} aria-label='Breadcrumb'>
      <ol className='mb-0 flex list-none flex-wrap items-center p-0'>
        {list.flatMap(({ text, link }, index) => {
          const isLast = index === lastIndex;
          const isLink = typeof link === 'string' && link !== '' && link !== '#';
          const showRouterLink = isLink && !isLast;

          const crumb = showRouterLink ? (
            <Link
              to={link}
              className='text-xs text-gray-600 transition-colors hover:text-blue-600 focus:outline-none focus-visible:rounded-ds-sm focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2'
            >
              {text}
            </Link>
          ) : isLast ? (
            <span className='text-xs font-semibold text-gray-900' aria-current='page'>
              {text}
            </span>
          ) : (
            <span className='text-xs text-gray-600'>{text}</span>
          );

          const out = [];
          if (index > 0) {
            out.push(
              <li key={`breadcrumb-sep-${index}`} className='mx-1 flex items-center text-gray-400' aria-hidden='true'>
                <ChevronRightIcon className='h-3.5 w-3.5 shrink-0' strokeWidth={2} />
              </li>
            );
          }
          out.push(
            <li key={`breadcrumb-crumb-${index}`} className='flex min-w-0 items-center'>
              {crumb}
            </li>
          );
          return out;
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
